import NumberFormat from "react-number-format";
import Link from 'next/link'
import { NextPage } from 'next';
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { IPaginationProp } from "./interfaces";


interface IProps {
  items: IPaginationProp
}

const PaginationComponent: NextPage<IProps> = ({ items }) => {
  const defaultClasses = 'cursor-pointer relative inline-flex items-center text-sm font-medium border'
  const pageItemActiveClasses = `${defaultClasses} px-4 py-2 text-pagination-active-text bg-pagination-active-bg border-pagination-border`
  const pageItemDefaultClasses = `${defaultClasses} px-4 py-2 bg-pagination-bg border-pagination-border text-pagination-text hover:bg-pagination-hover-bg`
  const prevItemClasses = `${defaultClasses} text-pagination-text bg-pagination-bg border-pagination-border hover:bg-pagination-hover-bg`
  const nextItemClasses = prevItemClasses

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-pagination-border sm:px-6">
      <div className="flex justify-between flex-1 sm:hidden">
        {items.prev && !items.prev.isDisabled && (
          items.type === 'callback' ? (
            <a
              onClick={() => items.callback ? items.callback(items.prev?.page) : {}}
              className={`${prevItemClasses} px-4 py-2`}
            >
              Previous
            </a>
          ) : (
            <Link href={(items.prev.isActive) ? items.prev.href : '#'}>
              <a
                className={`${prevItemClasses} px-4 py-2`}
              >
                Previous
              </a>
            </Link>
          )
        )}
        {items.next && !items.next.isDisabled && (
          items.type === 'callback' ? (
            <a
              onClick={() => items.callback ? items.callback(items.next?.page) : {}}
              className={`${nextItemClasses} px-4 py-2`}
            >
              Next
            </a>
          ) : (
            <Link href={(items.next.isActive) ? items.next.href : '#'}>
              <a
                className={`${nextItemClasses} px-4 py-2`}
              >
                Next
              </a>
            </Link>
          )
        )}
      </div>
      <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <div>
          <p className="text-sm text-pagination-text">
            <NumberFormat value={items.info?.totalPages} className={'text-caption'} displayType={'text'} thousandSeparator={true} /> Pages,{' '}
            <NumberFormat value={items.info?.totalRecords} className={'text-caption'} displayType={'text'} thousandSeparator={true} /> Results
          </p>
        </div>
        <div>
          <nav className="relative z-0 inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
            {items.prev && !items.prev.isDisabled && (
              items.type === 'callback' ? (
                <a
                  onClick={() => items.callback ? items.callback(items.prev?.page) : {}}
                  className={`${prevItemClasses} px-2 py-2 rounded-l-md`}
                >
                  <span className="sr-only">Previous</span>
                  <HiChevronLeft className="w-5 h-5" aria-hidden="true" />
                </a>
              ) : (
                <Link href={(items.prev.isActive) ? items.prev.href : '#'}>
                  <a
                    className={`${prevItemClasses} px-2 py-2 rounded-l-md`}
                  >
                    <span className="sr-only">Previous</span>
                    <HiChevronLeft className="w-5 h-5" aria-hidden="true" />
                  </a>
                </Link>
              )
            )}
            {items.pages && items.pages.map((item, idx) => (
              items.type === 'callback' ? (
                <a
                  aria-current="page"
                  key={idx}
                  onClick={() => { items.callback ? items.callback(item.page) : {}}}
                  className={(item.isActive) ? pageItemActiveClasses : pageItemDefaultClasses}
                  // {...(item.isActive ?
                  //   { className: 'relative inline-flex items-center px-4 py-2 text-sm font-medium text-indigo-600 border border-indigo-500 bg-indigo-50' }
                  //   : { className: 'relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 hover:bg-gray-50' })
                  // }
                >
                  {item.label}
                </a>
              ) : (
                <Link href={(item.isActive) ? '#' : item.href} key={idx}>
                  <a
                    aria-current="page"
                    className={(item.isActive) ? pageItemActiveClasses : pageItemDefaultClasses}
                    // {...(item.isActive ?
                    //   { className: 'relative inline-flex items-center px-4 py-2 text-sm font-medium text-indigo-600 border border-indigo-500 bg-indigo-50' }
                    //   : { className: 'relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 hover:bg-gray-50' })
                    // }
                  >
                    {item.label}
                  </a>
                </Link>
              )
            ))}
            {items.next && !items.next.isDisabled && (
              items.type === 'callback' ? (
                <a
                  onClick={() => items.callback ? items.callback(items.next?.page) : {}}
                  className={`${nextItemClasses} px-2 py-2 rounded-r-md`}
                >
                  <span className="sr-only">Next</span>
                  <HiChevronRight className="w-5 h-5" aria-hidden="true" />
                </a>
              ) : (
                <Link href={(items.next.isActive) ? items.next.href : '#'}>
                  <a
                    className={`${nextItemClasses} px-2 py-2 rounded-r-md`}
                  >
                    <span className="sr-only">Next</span>
                    <HiChevronRight className="w-5 h-5" aria-hidden="true" />
                  </a>
                </Link>
              )
            )}
          </nav>
        </div>
      </div>
    </div>
  )
}

export default PaginationComponent
